import React, { Component } from 'react'
import Map from '../components/Map'
import injectSheet from 'react-jss'
import queryString from 'query-string'

const styles = {
  farmInfoPage: {
    margin: '0 2rem',
    display: 'flex',
    flexWrap: 'no-wrap',
    flexDirection: 'column',
    alignItems: 'center',
  },
  farmInfoHeader: {
    textAlign: 'center',
    textTransform: 'uppercase',
    width: '100%',
    fontSize: '1.3rem',
    '& a': {
      color: 'rgb(153, 153, 153)',
      fontFamily: 'Proxima Nova',
      fontWeight: 'normal',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
        color: 'rgba(153, 153, 153, 0.7)',
      },
    },
  },
  farmInfoDiv: {
    width: '100%',
    letterSpacing: '0.08rem',
    lineHeight: '1.3rem',
    fontFamily: 'Proxima Nova',
    fontSize: '1.15rem',
    display: 'flex',
    flexDirection: 'column-reverse',
  },
  mapCanvasContainer: {
    minWidth: '100%',
    minHeight: '10rem',
  },
  mapCanvas: {
    width: '100%',
    height: '20rem',
  },
  farmCommDiv: {
    display: 'inline-block',
    marginBottom: '1rem',
    width: '100%',
    height: 'auto',
  },
  farmDistDiv: {
    display: 'inline-block',
    width: '100%',
  },
  commList: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    width: 'auto',
    height: 'auto',
    padding: 0,
    lineHeight: '1.5rem',
    letterSpacing: '0.1rem',
    fontSize: '0.90rem',
  },
  commListIE: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    width: 'auto',
    height: 'auto',
    padding: 0,
    lineHeight: '1.5rem',
    letterSpacing: '0.1rem',
    fontSize: '0.90rem',
  },
  commItem: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  distList: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'auto',
    flexWrap: 'wrap',
    width: '100%',
    padding: 0,
    lineHeight: '1.5rem',
    letterSpacing: '0.1rem',
    fontSize: '0.90rem',
  },
  distItem: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  farmImgContainer: {
    margin: '1rem auto 0',
    maxWidth: '100%',
    padding: '0',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  responsiveImage: {
    width: '100%',
  },
  cell: {
    margin: '0.5rem',
    '& img': {
      display: 'block',
    },
  },
  '@media (min-width: 600px)': {
    grid: {
      flex: '1 100%',
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
    cell: {
      width: 'calc(50% - 2rem)',
    },
    commList: {
      maxHeight: '20rem',
    },
    commListIE: {
      height: '20rem',
    },
  },
  '@media (min-width: 992px)': {
    farmInfoPage: {
      margin: '0 10.5rem',
    },
    farmInfoHeader: {
      textAlign: 'center',
      width: '100%',
    },
    farmInfoDiv: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: 'auto',
    },
    farmStoryContainer: {
      flex: 1,
      paddingRight: '1rem',
    },
    storyText: {
      marginTop: '0',
    },
    mapCanvasContainer: {
        height: '20rem',
        minWidth: '50%',
        // float: 'right',
        flex: 1,
        
    },
    mapCanvasContainerIE: {
      height: '20rem',
      minWidth: '50%',
      maxWidth: '50%',
      '-ms-flex': 1,
    },
    mapCanvas: {
      width: '100%',
      height: '100%',
    },
    commList: {
      maxHeight: '15rem',
    },
    commListIE: {
      height: '15rem',
    },
  },
  '@media (min-width: 1256px)': {
    //mapCanvasContainer: {
    //  margin: '1em 0 1em 2rem',
    //  minWidth: '24rem',
    //  height: '14rem',
    //},
    farmInfoPage: {
      margin: '0 21.5rem',
    },
    cell: {
      width: 'calc(25% - 2rem)',
    },
  },
  //'@media (min-width: 1400px)': {
  //  mapCanvasContainer: {
  //    minWidth: '25.5rem',
  //    height: '15.5rem',
  //  },
  //},
  '@media (min-width: 1600px)': {
    farmInfoPage: {
      margin: '0 32.5rem',
    },
  },
}

class FarmInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    this.props.getFarmInfo(
      queryString.parse(this.props.history.location.search).farm
    )
  }

  render() {
    const {
      classes,
      filteredFarms,
      history,
      getMapCenter,
      selectedFarm,
      updateMapCenter
    } = this.props

    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!document.documentMode

    const farm = [selectedFarm]

    const commodities = selectedFarm
      ? selectedFarm.Commodities.map((commodity) =>
        ({ 'name': commodity.Name, 'id': commodity.CommID }))
        .sort((a, b) => {
          const nameA = a.name.toUpperCase()
          const nameB = b.name.toUpperCase()
          if(nameA < nameB) {
            return -1
          }
          if(nameA > nameB) {
            return 1
          }
          return 0
        })
      : null

    const distributors = selectedFarm
      ? selectedFarm.Distributors.map((distributor) =>
        ({ 'name': distributor.Name, 'id': distributor.DistID }))
        .sort((a, b) => {
          const nameA = a.name.toUpperCase()
          const nameB = b.name.toUpperCase()
          if(nameA < nameB) {
            return -1
          }
          if(nameA > nameB) {
            return 1
          }
          return 0
        })
      : null

    return (selectedFarm) && (
      <div className={classes.farmInfoPage}>
        <div className={classes.farmInfoHeader}>
          <h1 style={{ flex: 1 }} ><a href={selectedFarm.Website} target='_blank'>{selectedFarm.Name}</a></h1>
        </div>
        <div className={classes.farmInfoDiv}>
          <div className={classes.farmStoryContainer}>
            <p className={classes.storyText}>{selectedFarm.Story}</p>
          </div>
          <Map
            changeActiveWindow={this.changeActiveWindow}
            containerElement={<div className={isIE ? classes.mapCanvasContainerIE : classes.mapCanvasContainer} />}
            filteredFarms={[selectedFarm]}
            history={history}
            mapCenter={{ lat: selectedFarm.Lat, lng: selectedFarm.Lng }}
            mapElement={<div className={classes.mapCanvas} />}
            selectedFarm={selectedFarm}
          />
        </div>
        {
          (commodities.length > 0) && (
            <div className={classes.farmCommDiv}>
              <h4>Available Commodities:</h4>
              <ul className={isIE ? classes.commListIE : classes.commList}>
                {commodities.map((commodity) => (
                  <li
                    className={classes.commItem}
                    key={commodity.id}
                  >
                    {commodity.name}
                  </li>
                )).sort()}
              </ul>
            </div>
          )
        }
        {
          (distributors.length > 0) && (
            <div className={classes.farmDistDiv}>
              <h4>Potential Distributors:</h4>
              <ul className={classes.distList}>
                {distributors.map((distributor) => (
                  <li
                    className={classes.distItem}
                    key={distributor.id}
                  >
                    {distributor.name}
                  </li>
                ))}
              </ul>
            </div>
          )
        }
        <div className={classes.farmImgContainer}>
          <div className={classes.grid}>
            {selectedFarm.Images.map((image) => (
              <div
                className={classes.cell}
                key={image.ImageID}
              >
                <img
                  alt={'farm view'}
                  className={classes.responsiveImage}
                  key={image.ImageID}
                  src={`data:image/png;base64,${image.Pic}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default injectSheet(styles)(FarmInfo)



// WEBPACK FOOTER //
// ./src/views/FarmInfo.js